import { useEffect, useState } from "react";
import classes from "./Details.module.css"
import { FaPlay } from "react-icons/fa";
import { FaPlus } from "react-icons/fa";
import { IoPeople } from "react-icons/io5";
import { useParams } from "react-router-dom";
import { collection, doc, getDoc } from 'firebase/firestore';
import db from '../firebase';
const Details=()=> {
    const {id}=useParams();
    const newId = id.replace(/:/g, '');
console.log(newId);
    const [item, setItem] = useState({});

    useEffect(() => {
      const getItemById = async (id) => {
        const docRef = doc(db, 'movies', id);
        const docSnapshot = await getDoc(docRef);
        if (docSnapshot.exists()) {
          const data = docSnapshot.data();
          setItem(data);
        } else {
          console.log('Document does not exist!');
        }
      };
      getItemById(newId);
    }, []);
  useEffect(()=>{
    console.log(newId)
    console.log(item)
  },[item])
  return (
    <div style={{backgroundImage: `url(${item.backgroundImg})`,backgroundSize:"cover",borderImageRepeat:"no-repeat", height: "100vh",position:"relative",backgroundPosition:"center",display:"flex",alignItems:"center",marginTop:"70px"}}>
    <div className={classes.conainer}>
   <img src={item.titleImg} alt="" />
   <div className={classes.iconsss}>
<button className={classes.play}><FaPlay />PALY</button>
<button className={classes.trailer}><FaPlay />TRAILER</button>
<div className={classes.bgicon}>
< FaPlus/> 
</div>
<div className={classes.bgicon}>
< IoPeople/> 
</div>
   </div>
   <h5>{item.subTitle}</h5>
   <h6 style={{fontSize:"20px",fontWeight:"normal",marginTop:"10px"}}>{item.description}</h6>
    </div>
  </div>
  )
}

export default Details;
